import { useMemo } from "react";
import { RetornoBancariaItemsPaginate } from "core/features/retorno-bancario/typings";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";
import { Flex } from "@chakra-ui/react";

function useConciliacaoBancariaColumns() {
  return useMemo(() => {
    return [
      {
        title: "Liquidação",
        render: (item: RetornoBancariaItemsPaginate) => {
          return item.dataLiquidacao
            ? moment(item.dataLiquidacao).format("DD/MM/YY")
            : "---";
        },
      },
      {
        title: "Itens",
        render: (item: RetornoBancariaItemsPaginate) => {
          const diff = item.dataLiquidacao
            ? moment(item.dataVencimento).diff(item.dataLiquidacao, "days")
            : null;

          return (
            <Flex flexDir="column">
              <Flex>Cobrança {item.nossoNumero}</Flex>

              {diff !== null ? (
                <Flex mt="4px"> Liquidado {diff} dia(s) antes do vencimento </Flex>
              ) : null}
            </Flex>
          );
        },
      },
      {
        title: "Pago",
        render: (item: RetornoBancariaItemsPaginate) => {
          return item.valorPago ? formatMoney(item.valorPago) : "---";
        },
      },
    ];
  }, []);
}

export default useConciliacaoBancariaColumns;
